import { BaseProps } from '@/components/types'
import { ChangeEvent, FocusEvent, KeyboardEvent, useEffect, useState } from 'react'
import { TableInputWrapper } from '../types/table'

function TableNumberBox ( props: TableNumberBoxProps ) {
    const {
        value, width, height = '100%', textAlign = 'right', style, unitText,
        onChange,
        ...rest
    } = props
    const [ input, setInput ] = useState( String( value || 0 ) )

    useEffect( () => {
        setInput( inputNumberWithComma( String( value || 0 ) ) )
    }, [ value ] )

    const onFocus = ( e: FocusEvent<HTMLInputElement> ) => {
        e?.target.select()
    }

    const onCustomChange = ( e: ChangeEvent<HTMLInputElement> ) => {
        const targetValue = inputNumberRemoveComma( inputNumber( e?.target?.value ) )

        if( !targetValue ) {
            setInput( '0' )
            return e.preventDefault()
        }
        if( !validateInputSize( targetValue ) ) return e.preventDefault()

        setInput( inputNumberWithComma( targetValue ) )
        onChange && onChange( Number( inputNumberRemoveComma( targetValue ) ) )

        e.preventDefault()
    }
    const inputNumber = ( value: string ): string =>{
        return value.replace( /[^0-9|.]/g, '' )
    }
    const inputNumberWithComma = ( value: string ): string =>  {
        if ( !value ) return '0'

        if ( value.indexOf( '.' ) > -1 ) {
            const [ beforeDotValue, afterDotValue ] = value.split( '.' )
            return `${ Number( beforeDotValue ).toLocaleString() }.${ afterDotValue }`
        }

        return Number( value ).toLocaleString()
    }
    const inputNumberRemoveComma = ( value: string ): string => value.replace( /,/g, '' )

    const validateInputSize = ( value: string ): boolean => {
        let valueCheck = true
        const removeCommaValue = inputNumberRemoveComma( value )
        const [ beforeDotValue ] = removeCommaValue.split( '.' )

        if ( beforeDotValue.length > 15 ) valueCheck = false

        return valueCheck
    }

    const onKeyDown = ( e: KeyboardEvent<HTMLInputElement> ) => {
        const { code, key } = e
        switch ( code ) {
            case 'Minus':
            case 'NumpadSubtract': {
                if ( !input ) return e.preventDefault()
                const arrInput = Array.from( String( input ) )
                const [ firstInputChar ] = arrInput

                firstInputChar === '-' ? arrInput.shift() : arrInput.unshift( key )

                setInput( arrInput.join( '' ) )
                e.preventDefault()
                break
            }
            case 'KeyE':
                e.preventDefault()
                break
            case 'Backspace':
            case 'Period':
                break
        }
    }

    return (
        <div className="table-input-wrapper">
            <div className="table-input-container flex">
                <input
                    { ...rest }
                    className="table-number-box"
                    value={ input }
                    style={ { textAlign, ...style, width, height, } }
                    onKeyDown={ onKeyDown }
                    onChange={ onCustomChange }
                    onFocus={ onFocus }
                />
                { unitText && <div className="table-text-unit">{ unitText }</div> }
            </div>
        </div>
    )
}

export default TableNumberBox

export interface TableNumberBoxProps extends BaseProps, TableInputWrapper<number> {}